"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const WirelessPointsBulkValidate_1 = __importDefault(require("./WirelessPointsBulkValidate"));
const WirelessPointsBulkUpdate_1 = __importDefault(require("./WirelessPointsBulkUpdate"));
const WirelessPointsBulkCreate_1 = __importDefault(require("./WirelessPointsBulkCreate"));
const SwitchesBulkValidate_1 = __importDefault(require("./SwitchesBulkValidate"));
const SwitchesBulkUpdate_1 = __importDefault(require("./SwitchesBulkUpdate"));
const SwitchesBulkCreate_1 = __importDefault(require("./SwitchesBulkCreate"));
const WirelessPoints_1 = __importDefault(require("./WirelessPoints"));
const Switches_1 = __importDefault(require("./Switches"));
const Networks_1 = __importDefault(require("./Networks"));
const Devices_1 = __importDefault(require("./Devices"));
const Users_1 = __importDefault(require("./Users"));
const Tasks_1 = __importDefault(require("./Tasks"));
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/emergency-address-auto-update`;
    }
    tasks(taskId = null) {
        return new Tasks_1.default(this, taskId);
    }
    users() {
        return new Users_1.default(this);
    }
    devices() {
        return new Devices_1.default(this);
    }
    networks(networkId = null) {
        return new Networks_1.default(this, networkId);
    }
    switches(switchId = null) {
        return new Switches_1.default(this, switchId);
    }
    wirelessPoints(pointId = null) {
        return new WirelessPoints_1.default(this, pointId);
    }
    switchesBulkCreate() {
        return new SwitchesBulkCreate_1.default(this);
    }
    switchesBulkUpdate() {
        return new SwitchesBulkUpdate_1.default(this);
    }
    switchesBulkValidate() {
        return new SwitchesBulkValidate_1.default(this);
    }
    wirelessPointsBulkCreate() {
        return new WirelessPointsBulkCreate_1.default(this);
    }
    wirelessPointsBulkUpdate() {
        return new WirelessPointsBulkUpdate_1.default(this);
    }
    wirelessPointsBulkValidate() {
        return new WirelessPointsBulkValidate_1.default(this);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map